import { DesignSystemIconType } from '@/components/Common/DesignSystem/Icon/IconCommon';
import { importAll } from '../importer';

const common = {} as Record<DesignSystemIconType, string>;

/*
 * jest 실행을 위한 코드 분기
 * require.context 는 jest 에서 실행되지 않음
 * */
try {
  importAll(require['context']('.', false, /\.svg$/), common);
} catch (error) {
  console.log(error.message);
}

export { common };
